import { getColorValue } from '../lib/utils';

import type { IconProps } from '.';

export const User = ({ bgColor = 'illustration-face', fgColor = 'illustration-line', size = 64 }: IconProps) => {
  const bgHsl = getColorValue(bgColor);
  const fgHsl = getColorValue(fgColor);

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
      <circle cx="31" cy="32" r="25" fill={bgHsl} />
      <path
        fill={fgHsl}
        d="M58.2 31.8c0-6.7-2.8-13-8-18.2a25.4 25.4 0 0 0-36.6-.2 25 25 0 0 0 .2 36.5 27 27 0 0 0 16.1 8.2h.1a21.2 21.2 0 0 0 4.2 0 26.3 26.3 0 0 0 24-26.3Zm-50 0c0-6.2 2.6-12 7.2-16.6A23.4 23.4 0 0 1 32 8.3c6.3 0 11.8 2.5 16.5 7 3.3 3.4 7.2 9 7.2 16.5 0 5.7-2 11-5.6 15.4C44.5 37 34.8 35.4 27.6 35.8a23 23 0 0 0-9 4.1 11.2 11.2 0 0 0-4.3 7 23 23 0 0 1-6-15v-.1Z"
      />
      <path
        fill={fgHsl}
        d="M27.8 32.1c1 .4 2.2.6 3.4.6 1.9 0 3.8-.5 5.8-1.5 2.2-1.2 3.5-2.7 4-4.4a6 6 0 0 0-2.5-6.1c-1.4-1-3-1.4-4.5-1.8l-1-.3c-4.3-1.2-8.9 2-10 5.6-.5 1.3-1.4 5.6 4.8 8Z"
      />
    </svg>
  );
};
